import React from 'react'
import FormMultiImages from 'components/forms/image/FormMultiImages'
import { updateObject } from 'helpers/objectHelpers'

const ProductCardConten = ({
  value,
  value: {
    images = [],
  },
  onRerender,
  onChange,
}) => {
  const handleChange = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  return (
    <FormMultiImages
      value={images}
      onChange={(val) => {
        onRerender()
        return handleChange(val, 'images')
      }}
    />
  )
}

ProductCardConten.propTypes = {}
ProductCardConten.defaultProps = {}

export default ProductCardConten



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/imageCarousel/ImageCarouselContent.js